<template>
  <div @keyup.enter="enterSearch">
    <el-form :model="form" ref="form" class="table-search-bar" inline label-width="110px">
      <el-form-item label="发货区域" prop="areaName">
        <el-input v-model="form.areaName" placeholder="请输入"></el-input>
      </el-form-item>
      <!-- <el-form-item label="主账号客户名称" prop="masterCustomerName">
        <el-input v-model="form.masterCustomerName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="子账号手机号" prop="subAccountPhone">
        <el-input v-model="form.subAccountPhone" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="子账号用户名" prop="subUserName">
        <el-input v-model="form.subUserName" placeholder="请输入"></el-input>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" v-permission="'0010902'" @click="handleAdd" >新增</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      tooltip-effect="light"
      style="width: 100%">
      <el-table-column
        prop="description"
        label="区域名称"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="createPerson"
        label="创建人"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="操作" width="300px">
        <template slot-scope="scope">
          <el-button size="mini" v-permission="'0010903'" @click="handleCheck(scope.$index, scope.row)" >编辑</el-button>
          <!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" v-permission="'0030404'">编辑</el-button> -->
          <el-button size="mini" type="danger" v-permission="'0010904'" @click="handleDel(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
   <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20 ,50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
     <!--
    <el-row class="export-row" type="flex" justify="end">
      <div class="mr10">
        每页
        <el-select class="width100" v-model="pageSize" @change="handleExportSizeChange">
          <el-option v-for="item in sizeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
          </el-option>
        </el-select>
        条
      </div>
      <div class="mr10">
        第
        <el-select class="width100" v-model="pageNo">
          <el-option
            v-for="item in pageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        页
      </div> -->
      <!-- <div class="">
        <el-button type="primary" @click="handleExportCSV">导出为CSV文件</el-button>
      </div> -->
    <!-- </el-row> -->
    <editDialog :show.sync="addOrEditDialogShow" :info="checkData" :isEdit="isEdit" @addOrEditClose= "addOrEditClose"/>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import editDialog from './editDialogShow'

export default {
  name: 'handleAreaSet',
  components: { editDialog },
  data () {
    return {
      form: {
        areaName: ''
      },
      isEdit: false,
      addOrEditDialogShow: false,
      pageNo: 1,
      pageSize: 10,
      sizeOptions: [
        {
          label: '10',
          value: 10
        },
        {
          label: '20',
          value: 20
        },
        {
          label: '50',
          value: 50
        },
        {
          label: '100',
          value: 100
        }
      ]
    }
  },
  computed: {
    ...mapState({
      list: state => state.handleAreaSet.list,
      listState: state => state.handleAreaSet.listState
    }),
    pageOptions () {
      const total = this.listState.total
      const size = this.pageSize
      let totalPage = Math.floor(total / size)
      if (total % size) {
        totalPage++
      }
      const arr = []
      for (let index = 1; index <= totalPage; index++) {
        arr.push({
          label: index,
          value: index
        })
      }
      return arr
    }
  },
  mounted () {
    console.log(this.listState)
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getseveHandAreas', 'deleteHandOrder']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSizeChange (val) {
      this.getseveHandAreas({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getseveHandAreas({ pageNo: val })
    },
    handleSearch () {
      const params = {
        ...this.form,
        pageNo: 1
      }
      this.getseveHandAreas(params)
    },
    // 导出每页条数变动监听
    handleExportSizeChange (val) {
      this.pageNo = 1
    },
    addOrEditClose () {
      this.handleSearch()
    },
    //
    handleExportCSV () {
      if (!Array.isArray(this.list) || this.list.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.primaryAccountExport({ ...this.form, pageNo: this.pageNo, pageSize: this.pageSize }).then((res) => {
          function createDownloadFile () {
            let blob = new Blob([res])
            let link = document.createElement('a')
            link.download = '子账号资金.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      }).catch(() => {})
    },

    // 新增
    handleAdd (index, row) {
      this.checkData = {}
      this.isEdit = false
      this.addOrEditDialogShow = true
    },
    // 编辑
    handleCheck (index, row) {
      this.isEdit = true
      console.log(row)
      this.checkData = row
      this.addOrEditDialogShow = true
    },
    handleReset () {
      this.$refs['form'].resetFields()
      this.handleSearch()
    },
    handleDel (index, row) {
      this.$confirm('是否确认删除', '删除提醒', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.deleteHandOrder({ id: row.id }).then(res => {
          this.$message.success('删除成功')
          this.handleSearch()
        })
      }).catch(() => {
        // 取消删除
      })
    }

  }
}
</script>
<style lang="scss" scoped>
  .export-row {
    margin-top: 10px;
  }
  .mr10{
    margin-right: 10px;
  }
</style>
